module.exports = __webpack_public_path__ + "static/media/IMG-6.dd9eac15.jpg";